// extracted by mini-css-extract-plugin
export default {"hiddenOnMobile":"FooterContainer_hiddenOnMobile__MTjF8"};